import { mocksLocationData } from '../mocks';

export const getLocations = () => {
  if (process.env.REACT_APP_SQUARE_MOCK === 'true') {
    return new Promise<typeof mocksLocationData>(r => {
      setTimeout(() => {
        r(mocksLocationData);
      }, 1000);
    });
  } else {
    throw new Error('There\'s no such API Yet (Square/getlocations)');
  }
}